var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-system-bar',[_vm._v("Pfade")]),_c('v-treeview',{attrs:{"items":_vm.hierarchy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }